import type { ReactNode } from "react";
import { BAR_SLOT } from "./nav/XaleBar";

/**
 * A desktop page shown inside the phone shell (Settings, Reports, the HR
 * suite…): it keeps its own layout and scrolls under the bar. `.main` sizes
 * itself as 100vh minus `--header-height`, which the shell sets to the bar's
 * slot, so the page's own scroll area already stops above the bar.
 */
export default function DesktopPageFrame({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-[100dvh] overflow-y-auto" style={{ paddingBottom: BAR_SLOT + 10 }}>
      {children}
    </div>
  );
}
